import Api from "./Api";

export default {
  submitForm(formData) {
    return Api().post("/form/submit", {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      token: formData.token,
    });
  },
  submitQuotationForm(formData) {
    return Api().post("/form/submitQuotationForm", {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      notes: formData.notes,
      companyName: formData.companyName,
      token: formData.token,
      guestCart: JSON.stringify(formData.guestCart),
    });
  },
  sendRequestAddToPriceList(RequestObj) {
    return Api().post("/form/sendRequestAddToPriceList", RequestObj);
  },
};
